import {} from "axios";
import { microserviceApiAxios } from "../../microservice-api.axios";
import { microserviceApiRoutes } from "../../microservice-api.routes";

export const preCreatePolicyAgents = (data: any) => {
  const url = microserviceApiRoutes.v1.agents.policy.preCreate();
  return microserviceApiAxios.post(url, data).then((res) => res.data);
};
